import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';
import IconButton from 'material-ui/IconButton';
import SvgIcon from 'material-ui/SvgIcon';

import { importUsersFromCsv } from '../../actions/userActions';

import {
  Container,
  FormContainer,
  FormGroup,
  FormTitle,
  Pre,
  Code,
  styles
} from '../Styles/index';

class ImportForm extends Component {
  state = {
    userFileName: "No file chosen",
    userFile: null,
    completed: 45
  }

  _handleChange = event => {
    if (!event.target.files.length) return;

    const data = new FormData();
    data.append('userFile', event.target.files[0]);
    this.setState({
      userFile: data,
      userFileName: event.target.files[0] ? event.target.files[0].name : "No file chosen"
    })
  }

  _handleSubmit = event => {
    event.preventDefault();
    console.log(event);
    this.props.importUsersFromCsv(this.state.userFile || {});
  }

  componentDidMount() {

    const data = new FormData();
    data.append('userFile', '');
    this.setState({
      userFile: data,
      userFileName: "No file chosen"
    })
  }

  render() {
    return (
      <form onSubmit={this._handleSubmit}>
        <Container>
          <FormContainer>
            <FormGroup>
              <FormTitle>Import Users</FormTitle>
            </FormGroup>
            <FormGroup style={{display: 'flex', alignItems: 'center'}}>
              <RaisedButton
                type='submit'
                label="Choose file"
                labelPosition="before"
                style={styles.uploadButton}
                containerElement="label">
                <input type="file" name="userFile" id="userFile" onChange={this._handleChange} style={styles.uploadInput} />
              </RaisedButton>
              <label style={{paddingLeft: '8px'}}>{this.state.userFileName}</label>
              <IconButton tooltip="Upload csv file" style={{marginLeft: '8px'}}>
                <SvgIcon >
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                </SvgIcon>
              </IconButton>
            </FormGroup>
            <FormGroup>
              <RaisedButton type='submit' label="Upload" primary={true} />
            </FormGroup>
            {this.props.imports.status === 'importing' &&
              <FormGroup>
                <LinearProgress style={{background: '#dfdfdf'}} mode="indeterminate"/>
              </FormGroup>
            }
            <FormGroup>
              <Pre>
                <Code>
                  {`${JSON.stringify(this.props.imports.log || this.props.imports.error || 'No Log', undefined, 2)}`}
                </Code>
              </Pre>
            </FormGroup>
          </FormContainer>
        </Container>
      </form>
    );
  }
}


const mapStateToProps = state => ({ imports: state.user.import });
const mapDispatchToProps = { importUsersFromCsv };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ImportForm));



// WEBPACK FOOTER //
// ./src/components/Users/ImportForm.js